export default __webpack_public_path__ + "static/media/step2.1c5491f3.svg";